import type { Strings } from '../i18n/strings';
import type { RoleKey } from '../lib/staffContext';

export function roleLabel(t: Strings, role: RoleKey): string {
  switch (role) {
    case 'platform_admin':
      return t['role.platformAdmin'];
    case 'school_admin':
      return t['role.schoolAdmin'];
    case 'head_of_school':
      return t['role.headOfSchool'];
    case 'counsellor':
      return t['role.counsellor'];
    case 'teacher':
      return t['role.teacher'];
    case 'municipality_coordinator':
      return t['r3.role.coordinator'];
  }
}

export function roleDescription(t: Strings, role: RoleKey): string {
  switch (role) {
    case 'platform_admin':
      return t['role.platformAdminDesc'];
    case 'school_admin':
      return t['role.schoolAdminDesc'];
    case 'head_of_school':
      return t['role.headOfSchoolDesc'];
    case 'counsellor':
      return t['role.counsellorDesc'];
    case 'teacher':
      return t['role.teacherDesc'];
    case 'municipality_coordinator':
      return t['r3.role.coordinatorDesc'];
  }
}
